<template>
  <div>
    <ValidationObserver
      autocomplete="off"
      tag="form"
      v-slot="{ handleSubmit }"
      @submit.prevent
    >
      <h3 class="form-legend font-size-h3 bb-1 mb-5">{{ $content.sign_up }}</h3>

      <div class="mb-3">
        <label for="signUpEmail" class="label">{{ $content.your_email }}:</label>
        <ValidationProvider
          autocomplete="off"
          mode="lazy"
          rules="required|email"
          v-slot="{ errors }">
          <input id="signUpEmail" type="text" class="form-control" v-model="userEmail" autocomplete="false">
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div class="mb-3">
        <label for="signUpPassword" class="label">{{ $content.password }}:</label>
        <ValidationProvider
          autocomplete="off"
          mode="lazy"
          rules="required"
          vid="password"
          v-slot="{ errors }">
          <input id="signUpPassword" type="password" class="form-control" v-model="userPassword">
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div class="mb-3">
        <label for="signUpPasswordRepeat" class="label">{{ $content.password_confirm }}:</label>
        <ValidationProvider
          autocomplete="off"
          mode="lazy"
          rules="required|confirmed:password"
          v-slot="{ errors }">
          <input id="signUpPasswordRepeat" type="password" class="form-control" v-model="userPasswordConfirm">
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>


      <div class="mb-3">
        <ValidationProvider
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }">
          <label class="checkbox">
            <input type="checkbox" v-model="terms_cb">
            <span class="check"></span>
            <span>{{ $content.sign_in_term[0] }}<a class="c-pink terms" href="https://magazynpismo.pl/regulamin/" target="_blank">{{ $content.sign_in_term[1] }}</a>{{ $content.sign_in_term[2] }} *</span>
          </label>
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div class="mb-3">
        <ValidationProvider
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }">
          <label class="checkbox">
            <input type="checkbox" v-model="gdpr_cb">
            <span class="check"></span>
            <span>{{ $content.gdpr }} *</span>
          </label>
          <div
            class="frame-scroll-y mt-1"
            v-html="processingTerms">
          </div>
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div class="mb-3">
        <label class="checkbox">
          <input type="checkbox" v-model="newsletter_cb">
          <span class="check"></span>
          <span>{{ $content.subscription_mailing }}</span>
        </label>
      </div>

      <div>
        <p v-show="showError" class="c-pink mb-2">{{ errorMessage }}</p>
        <button
          @click="handleSubmit(signUp)"
          type="submit"
          class="btn btn-primary btn-max">
          {{ $content.sign_up }}
        </button>
      </div>
      <small class="d-inline c-gray mt-1">{{ $content.required_fields }}</small>

    </ValidationObserver>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver  } from 'vee-validate';
  import UserDataMixin from '../mixins/userdata';

  export default {
    name: 'SignUpForm',
    mixins: [ UserDataMixin ],
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data() {
      return {
        userEmail: '',
        userPassword: '',
        userPasswordConfirm: '',
        terms_cb: false,
        gdpr_cb: false,
        newsletter_cb: false,
        showError: false,
        errorMessage: '',
        processingTerms: this.$appInfo.init.registration_form.processing_info,
        mailingTerms: this.$appInfo.init.registration_form.mailing_regulations_info
      }
    },
    methods: {
      signUp() {
        this.errorMessage = '';
        let formData = new FormData();
        formData.append('form[email]', this.userEmail);
        formData.append('form[password]', this.userPassword);
        formData.append('form[confirm_password]', this.userPasswordConfirm);
        formData.append('form[terms_cb]', this.terms_cb ? '1': '0');
        formData.append('form[gdpr_cb]', this.gdpr_cb ? '1': '0' );
        // formData.append('form[mailing_cb]', this.mailing_cb ? '1': '0');
        formData.append('form[newsletter_cb]', this.newsletter_cb ? '1' : '0');

        this.$http.post('/wp-admin/admin-ajax.php?action=app_new_user_form', formData)
          .then(response => {
            if (response.status === 200) {
              if (response.data.error) {
                this.showError = true;
                this.errorMessage = response.data.error;
              } else {
                this.$store.commit('setUserName', { name: this.userEmail });
                this.$store.dispatch('signIn');

                this.fetchUserData();
                this.$gtm.trackEvent({
                  event: 'sign_up',
                  category: 'prenumerata',
                  action: 'sign_up',
                  label: 'user',
                  value: response.data.user_id,
                  user_id: response.data.user_id
                });
                this.nextStep();
              }
            }
          })
          .catch(error => {
          });
      },
      nextStep() {
        if (this.$store.state.selectedPlan.type === 'digital' && !this.$store.state.giftData.isGift ) {
          this.$store.commit('setActiveStep', { activeStep: 'SummaryStep' });
        } else {
          this.$store.commit('setActiveStep', { activeStep: 'DeliveryStep' });
        }
      }
    }
  }
</script>
